import { render, staticRenderFns } from "./DialogForAllSchool.vue?vue&type=template&id=4865503d&scoped=true&"
import script from "./DialogForAllSchool.vue?vue&type=script&lang=js&"
export * from "./DialogForAllSchool.vue?vue&type=script&lang=js&"
import style0 from "./DialogForAllSchool.vue?vue&type=style&index=0&id=4865503d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4865503d",
  null
  
)

export default component.exports